<template>
  <div>
    <b-modal
      v-model="modalStatus"
      centered
      size="md"
      button-size="sm"
      no-close-on-backdrop
    >
      <template #modal-header>
        <h5 class="modal-title" v-if="!sendedStatus">Save List</h5>
        <h5 class="modal-title" v-else>Done!</h5>
        <button type="button" class="close" @click="closeModal()">×</button>
      </template>
      <b-alert v-model="hasUnknownError" variant="danger" fade>
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger" fade>
        {{ errorMessage }}
      </b-alert>

      <div v-if="importedListSavingState && !sendedStatus">
        <div v-if="importedListSavingState === 2" class="info-message">
          <p>The imported list can not be edited anymore. If you want to save your changes as a new list, write a new list name and click 'save new list'</p>
          <div class="imported-lists">
            <p>Imported List:</p>
            <div v-for="item in importedSavedLists" :key="item.field_001">
              <p class="listitem">- {{ item.bezeichnung }}</p>
            </div>
          </div>
        </div>
        <div v-else-if="importedListSavingState === 3" class="info-message">
          <p>Do you want to save the edits to your imported list?<br>If yes, then keep the original list name and click 'save changes'.</p>
          <p>Otherwise, write a new list name and click 'save new list'."</p>
          <div class="imported-lists">
            <p>Imported List:</p>
            <div v-for="item in importedSavedLists" :key="item.field_001">
              <p class="listitem">- {{ item.bezeichnung }}</p>
            </div>
          </div>
        </div>
        <div v-else-if="importedListSavingState === 4" class="info-message">
          <p>The imported list can not be edited anymore, because you imported more than one list.<br>
            If you want to save your changes as a new list, write a new list name and click 'save new list'</p>
          <div class="imported-lists">
            <p>Imported Lists:</p>
            <div v-for="item in importedSavedLists" :key="item.field_001">
              <p class="listitem">- {{ item.bezeichnung }}</p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!sendedStatus">
        <validation-observer ref="observer" v-slot="{ passes }">
          <b-form @submit.prevent="passes(onSubmit)">
            <b-form-row>
              <b-col lg="12">
                <validation-provider vid="title" rules="required" v-slot="{ valid, errors, changed }">
                  <b-form-input
                    v-model="listTitle"
                    type="text"
                    :state="onValidateField(valid, errors, changed)"
                    placeholder="Title"
                  ></b-form-input>
                  <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-col>
            </b-form-row>
            <b-row>
              <b-col lg="12" class="mt-4">
                <small>The Creation of the list may take a moment depending on the amount of data. Please don't close the window.</small>
              </b-col>
              <b-col lg="12" class="right">
                <b-button v-if="importedListSavingState === 3 && isSubmittingOverwrite" variant="primary" size="sm" disabled class="mt-4 mr-2">
                  <b-spinner small></b-spinner>
                  list is changing...
                </b-button>
                <b-button v-else-if="importedListSavingState === 3" @click="overwriteList" class="mt-4 mr-2" size="sm" variant="primary" ref="submitEditPlotBtn">save changes</b-button>
                <b-button type="submit" variant="primary" size="sm" disabled v-if="isSubmitting" class="mt-4">
                  <b-spinner small></b-spinner>
                  list is saving...
                </b-button>
                <b-button class="mt-4" type="submit" size="sm" variant="primary" ref="submitEditPlotBtn" v-else>save new list</b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
      <div v-else>
        <p>The list was created successfully</p>
        <b-row>
          <b-col lg="6" class="left">
            <b-button variant="secondary" size="sm" @click="closeModal">Stay here</b-button>
          </b-col>
          <b-col lg="6" class="right">
            <b-button variant="primary" size="sm" @click="redirectToList">Go to created List</b-button>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            hidden
          >
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { validateField } from '@/helpers/formHelper.js'
  export default {
    name: 'save-list-modal',
    components: {
      ValidationObserver,
      ValidationProvider
    },
    props: {
      addressList: Array,
      importedSavedLists: Array
    },
    data () {
      return {
        isSubmitting: false,
        isSubmittingOverwrite: false,
        hasUnknownError: false,
        unknownErrorMessage: '',
        hasError: false,
        errorMessage: '',
        modalAlert: false,
        listTitle: '',
        createdListId: null,
        sendedStatus: false,
        failedAddresses: [],
        listIdToOverwrite: null,
        pressedButton: 1 // 1 = create list, 2 = overwrite list
      }
    },
    methods: {
      onSubmit () {
        const arrayOfAdressIds = []
        if (this.addressList) {
          for (const address in this.addressList) {
            arrayOfAdressIds.push(this.addressList[address].id)
          }
        }
        const list = {
          title: this.listTitle,
          addressID: this.mitarbeiterAddressID,
          arrayOfIds: arrayOfAdressIds,
          unicSession: this.generateGUID()
        }
        this.createRechercheList(list)
      },
      async createRechercheList (list) {
        try {
          const { errors, data } = await this.$store.dispatch('recherche/CREATE_LIST_AND_ADRESSES', {
            formData: list
          })
          if (errors) {
            this.isSubmitting = false
            throw errors
          } else {
            if (this.pressedButton === 2) {
              this.deleteAddressList(this.importedSavedLists[0].field_001)
            } else {
              this.createdListId = data.createCRMRechercheAdresslistWithAdresses.response.field_001
              this.isSubmitting = false
              this.sendedStatus = true
              this.$store.commit('recherche/SET_IMPORTEDSAVEDLISTES', [])
            }
          }
        } catch (err) {
          this.isSubmitting = false
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      createList () {
        this.pressedButton = 1
        this.isSubmitting = true
        this.onSubmit()
      },
      overwriteList () {
        this.pressedButton = 2
        this.isSubmittingOverwrite = true
        this.onSubmit()
      },
      async deleteAddressList (addressId) {
        try {
          const data = await this.$store.dispatch('recherche/DELETE_RECHERCHE_ADRESSLIST', addressId)
          if (data.data.deleteCRMRechercheAdresslistAndAdresses.ok) {
            this.isSubmittingOverwrite = false
            this.sendedStatus = true
            this.$store.commit('recherche/SET_IMPORTEDSAVEDLISTES', [])
          } else {
            this.isSubmittingOverwrite = false
            throw data.errors
          }
        } catch (err) {
          this.isSubmittingOverwrite = false
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      redirectToList () {
        this.sendedStatus = false
        this.$store.commit('recherche/SET_SAVE_LIST_STATUS', false)
        this.$router.push({
          name: 'recherche-detail',
          params: { id: this.createdListId }
        })
      },
      closeModal () {
        this.sendedStatus = false
        this.$store.commit('recherche/SET_SAVE_LIST_STATUS', false)
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      generateGUID () {
        function s4 () {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1)
            .toUpperCase()
        }
        return (
          s4() +
          s4() +
          '-' +
          s4() +
          '-' +
          s4() +
          '-' +
          s4() +
          s4() +
          s4() +
          s4()
        )
      }
    },
    computed: {
      importedListSavingState () {
        let status = 0
        if (this.importedSavedLists.length === 0) {
          status = 1
        } else if (this.importedSavedLists.length === 1) {
          if (this.importedSavedLists[0].mAILVersands && this.importedSavedLists[0].mAILVersands.length > 0) {
            status = 2
          } else {
            status = 3
          }
        } else if (this.importedSavedLists.length > 1) {
          status = 4
        } else {
          status = 0
        }
        return status
      },
      ...mapState({
        modalStatus: state => state.recherche.saveListStatus,
        currentUser: state => state.user.currentUser,
        mitarbeiterAddressID: state => state.user.mitarbeiterAddressID
      })
    },
    watch: {
      importedListSavingState () {
        if (this.importedListSavingState === 3) {
          this.listTitle = this.importedSavedLists[0].bezeichnung
        }
      }
    }
  }
</script>
